if (!customElements.get('certified-shipping-progress')) {
  customElements.define('certified-shipping-progress', class extends HTMLElement {
    connectedCallback() {
      this.sequence = 0;
      if (typeof subscribe === 'function') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          const data = event.cartData;
          if (data && Number.isFinite(data.total_price) && Number.isFinite(data.item_count)) {
            this.sequence++;
            this.update(data);
          } else {
            this.refresh();
          }
        });
      }
      this.onPageShow = () => this.refresh();
      window.addEventListener('pageshow', this.onPageShow);
    }
    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
      window.removeEventListener('pageshow', this.onPageShow);
      this.sequence++;
    }
    async refresh() {
      const sequence = ++this.sequence;
      try {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {headers: {Accept: 'application/json'}});
        if (!response.ok) return;
        const cart = await response.json();
        if (this.isConnected && sequence === this.sequence) this.update(cart);
      } catch {}
    }
    update(cart) {
      if (cart.currency && cart.currency !== this.dataset.currency) {
        this.hidden = true;
        return;
      }
      this.hidden = false;
      const goal = Number(this.dataset.goal);
      const remaining = Math.max(0, goal - cart.total_price);
      const amount = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style: 'currency', currency: this.dataset.currency}).format(remaining / 100);
      this.querySelector('.certified-shipping__message').textContent = cart.item_count === 0 ? this.dataset.empty : remaining > 0 ? this.dataset.remaining.replace('[amount]', amount) : this.dataset.unlocked;
      this.querySelector('progress').value = Math.min(100, Math.max(0, cart.total_price / goal * 100));
    }
  });
}
if (!customElements.get('certified-collection-tabs')) {
  customElements.define('certified-collection-tabs', class extends HTMLElement {
    connectedCallback() {
      this.buttons = [...this.querySelectorAll('[data-collection-target]')];
      this.panels = [...this.querySelectorAll('[data-collection-panel]')];
      this.onClick = (event) => {
        const button = event.target.closest('[data-collection-target]');
        if (button && this.contains(button)) this.show(button);
      };
      this.addEventListener('click', this.onClick);
      if (this.buttons.length) this.show(this.buttons[0]);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }
    show(button) {
      this.buttons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      this.panels.forEach((panel) => { panel.hidden = panel.id !== button.dataset.collectionTarget; });
    }
  });
}

if (!customElements.get('certified-floating-shirts')) {
  customElements.define('certified-floating-shirts', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-motion-toggle]');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onToggle = () => {
        const paused = !this.hasAttribute('data-paused');
        this.toggleAttribute('data-paused', paused);
        this.button.setAttribute('aria-pressed', String(paused));
        this.button.textContent = paused ? this.button.dataset.play : this.button.dataset.pause;
      };
      this.onMotionChange = () => {
        this.button.hidden = this.motion.matches;
      };
      this.button.addEventListener('click', this.onToggle);
      this.motion.addEventListener('change', this.onMotionChange);
      this.onMotionChange();
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.setAttribute('data-animated', '');
            this.observer.disconnect();
          }
        }, {threshold: 0.15});
        this.observer.observe(this);
      } else {
        this.setAttribute('data-animated', '');
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.button?.removeEventListener('click', this.onToggle);
      this.motion?.removeEventListener('change', this.onMotionChange);
    }
  });
}

(() => {
  const init = () => {
    const root = document.documentElement;
    const reminder = document.querySelector('[data-newsletter-reminder]');
    const formId = 'VdgsiT';
    const dialogSelector = '[role="dialog"]:has([data-testid="klaviyo-form-VdgsiT"])';
    let allowOpen = false;
    let automaticClose = false;
    let ready = false;
    let submitted = document.body.dataset.certifiedSubscriber === 'true';
    let dismissedUntil = 0;
    const read = (key) => { try { return localStorage.getItem(key); } catch { return null; } };
    const write = (key, value) => { try { localStorage.setItem(key, value); } catch {} };
    submitted = submitted || read('certified-newsletter-subscribed') === 'true';
    dismissedUntil = Number(read('certified-newsletter-dismissed-until')) || 0;
    const update = () => {
      root.toggleAttribute('data-newsletter-subscribed', submitted);
      if (!reminder) return;
      const travelled = window.scrollY / Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      const blocked = document.body.classList.contains('overflow-hidden') || document.querySelector('cart-drawer.active') || document.querySelector('#age-verification:not([style*="display: none"])') || document.querySelector('.certified-newsletter')?.getBoundingClientRect().top < innerHeight;
      reminder.hidden = !ready || submitted || Date.now() < dismissedUntil || travelled < 0.25 || !!blocked || allowOpen;
    };
    const dismiss = () => {
      dismissedUntil = Date.now() + 30 * 24 * 60 * 60 * 1000;
      write('certified-newsletter-dismissed-until', String(dismissedUntil));
      update();
    };
    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-newsletter-dismiss]')) dismiss();
      if (!event.target.closest('[data-newsletter-open]')) return;
      allowOpen = true;
      root.setAttribute('data-newsletter-open', '');
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', formId]);
      update();
      window.setTimeout(() => {
        if (document.querySelector(dialogSelector)) return;
        allowOpen = false;
        root.removeAttribute('data-newsletter-open');
        const status = document.querySelector('[data-newsletter-status]');
        if (status) status.textContent = status.dataset.unavailable;
        update();
      }, 5000);
    });
    window.addEventListener('klaviyoForms', (event) => {
      if (event.detail?.formId !== formId) return;
      if (event.detail.type === 'submit') {
        submitted = true;
        write('certified-newsletter-subscribed', 'true');
        update();
      }
      if (event.detail.type === 'close') {
        allowOpen = false;
        root.removeAttribute('data-newsletter-open');
        if (!automaticClose) dismiss();
        automaticClose = false;
        update();
      }
    });
    const observer = new MutationObserver(() => {
      const dialog = document.querySelector(dialogSelector);
      if (dialog && !allowOpen) {
        const close = dialog.querySelector('button[aria-label="Close dialog"]');
        if (close && !automaticClose) {
          automaticClose = true;
          close.click();
          window.setTimeout(() => { automaticClose = false; }, 1000);
        }
      }
      update();
    });
    observer.observe(document.body, {childList:true, subtree:true});
    window.addEventListener('scroll', update, {passive:true});
    window.addEventListener('resize', update, {passive:true});
    window.setTimeout(() => { ready = true; update(); }, 25000);
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
